module.exports = __webpack_public_path__ + "img/middleCarouseImg4.6b648be7.jpg";